import { z } from 'zod';

/** Codigo de outro sistema (ex.: Protheus) de um cadastro nosso. `importado` = veio de importacao (somente leitura). */
export const externoSchema = z.object({
  sistema: z.string().trim().min(1, 'Informe o sistema').max(50),
  colecao: z.string().trim().min(1, 'Informe o tipo do código').max(50),
  idExterno: z.string().trim().min(1, 'Informe o código').max(100),
});
export const externosSchema = z.object({ refs: z.array(externoSchema).max(20) });
export type SalvarExternosDto = z.infer<typeof externosSchema>;
/** GET /externos/resumo (aba Integracoes): quantos codigos de cada sistema externo a empresa tem, por tipo de cadastro. So contagem; os codigos se editam em cada cadastro. */
export interface ResumoExternosResponse {
  sistemas: Array<{ sistema: string; total: number; entidades: Array<{ entidade: string; rotulo: string; total: number }> }>;
}
export interface ExternoResponse {
  sistema: string;
  colecao: string;
  idExterno: string;
  importado: boolean;
}
